import { epicRequest, serverResponse } from 'app'
import System from 'system'

import { tournamentLastViewed } from 'components/sports/soccer/TournamentActions'

export const MATCH_FETCH = 'MATCH_FETCH'
export const MATCH_FETCH_ERROR = 'MATCH_FETCH_ERROR'
export const MATCH_FETCH_FULFILLED = 'MATCH_FETCH_FULFILLED'
export const MATCH_FETCH_CANCELED = 'MATCH_FETCH_CANCELED'

export const MATCH_APPROVE = 'MATCH_APPROVE'
export const MATCH_APPROVE_ERROR = 'MATCH_APPROVE_ERROR'
export const MATCH_APPROVE_FULFILLED = 'MATCH_APPROVE_FULFILLED'
export const MATCH_APPROVE_CANCELED = 'MATCH_APPROVE_CANCELED'

export const MATCH_AUDITS_FETCH = 'MATCH_AUDITS_FETCH'
export const MATCH_AUDITS_FETCH_ERROR = 'MATCH_AUDITS_FETCH_ERROR'
export const MATCH_AUDITS_FETCH_FULFILLED = 'MATCH_AUDITS_FETCH_FULFILLED'
export const MATCH_AUDITS_FETCH_CANCELED = 'MATCH_AUDITS_FETCH_CANCELED'

export const MATCH_DELETE = 'MATCH_DELETE'
export const MATCH_DELETE_ERROR = 'MATCH_DELETE_ERROR'
export const MATCH_DELETE_FULFILLED = 'MATCH_DELETE_FULFILLED'
export const MATCH_DELETE_CANCELED = 'MATCH_DELETE_CANCELED'

export const MATCH_DISAPPROVE = 'MATCH_DISAPPROVE'
export const MATCH_DISAPPROVE_ERROR = 'MATCH_DISAPPROVE_ERROR'
export const MATCH_DISAPPROVE_FULFILLED = 'MATCH_DISAPPROVE_FULFILLED'
export const MATCH_DISAPPROVE_CANCELED = 'MATCH_DISAPPROVE_CANCELED'

export const MATCH_SCHEDULE = 'MATCH_SCHEDULE'
export const MATCH_SCHEDULE_ERROR = 'MATCH_SCHEDULE_ERROR'
export const MATCH_SCHEDULE_FULFILLED = 'MATCH_SCHEDULE_FULFILLED'
export const MATCH_SCHEDULE_CANCELED = 'MATCH_SCHEDULE_CANCELED'

export const MATCH_LOCATION_SET = 'MATCH_LOCATION_SET'
export const MATCH_LOCATION_SET_ERROR = 'MATCH_LOCATION_SET_ERROR'
export const MATCH_LOCATION_SET_FULFILLED = 'MATCH_LOCATION_SET_FULFILLED'
export const MATCH_LOCATION_SET_CANCELED = 'MATCH_LOCATION_SET_CANCELED'

export const MATCH_REFEREE_SET = 'MATCH_REFEREE_SET'
export const MATCH_REFEREE_SET_ERROR = 'MATCH_REFEREE_SET_ERROR'
export const MATCH_REFEREE_SET_FULFILLED = 'MATCH_REFEREE_SET_FULFILLED'
export const MATCH_REFEREE_SET_CANCELED = 'MATCH_REFEREE_SET_CANCELED'

export const MATCH_RELATION_FETCH = 'MATCH_RELATION_FETCH'
export const MATCH_RELATION_FETCH_ERROR = 'MATCH_RELATION_FETCH_ERROR'
export const MATCH_RELATION_FETCH_FULFILLED = 'MATCH_RELATION_FETCH_FULFILLED'
export const MATCH_RELATION_FETCH_CANCELED = 'MATCH_RELATION_FETCH_CANCELED'

export const MATCH_TEAM_LIKE = 'MATCH_TEAM_LIKE'
export const MATCH_TEAM_LIKE_ERROR = 'MATCH_TEAM_LIKE_ERROR'
export const MATCH_TEAM_LIKE_FULFILLED = 'MATCH_TEAM_LIKE_FULFILLED'
export const MATCH_TEAM_LIKE_CANCELED = 'MATCH_TEAM_LIKE_CANCELED'

export const MATCH_TEAM_RELATION_FETCH = 'MATCH_TEAM_RELATION_FETCH'
export const MATCH_TEAM_RELATION_FETCH_ERROR = 'MATCH_TEAM_RELATION_FETCH_ERROR'
export const MATCH_TEAM_RELATION_FETCH_FULFILLED = 'MATCH_TEAM_RELATION_FETCH_FULFILLED'
export const MATCH_TEAM_RELATION_FETCH_CANCELED = 'MATCH_TEAM_RELATION_FETCH_CANCELED'

export const MATCH_EVENTS_FETCH = 'MATCH_EVENTS_FETCH'
export const MATCH_EVENTS_FETCH_ERROR = 'MATCH_EVENTS_FETCH_ERROR'
export const MATCH_EVENTS_FETCH_FULFILLED = 'MATCH_EVENTS_FETCH_FULFILLED'
export const MATCH_EVENTS_FETCH_CANCELED = 'MATCH_EVENTS_FETCH_CANCELED'

export const MATCH_REPORTS_FETCH = 'MATCH_REPORTS_FETCH'
export const MATCH_REPORTS_FETCH_ERROR = 'MATCH_REPORTS_FETCH_ERROR'
export const MATCH_REPORTS_FETCH_FULFILLED = 'MATCH_REPORTS_FETCH_FULFILLED'
export const MATCH_REPORTS_FETCH_CANCELED = 'MATCH_REPORTS_FETCH_CANCELED'

export const MATCH_REPORTS_DETAILS_FETCH = 'MATCH_REPORTS_DETAILS_FETCH'
export const MATCH_REPORTS_DETAILS_FETCH_ERROR = 'MATCH_REPORTS_DETAILS_FETCH_ERROR'
export const MATCH_REPORTS_DETAILS_FETCH_FULFILLED = 'MATCH_REPORTS_DETAILS_FETCH_FULFILLED'
export const MATCH_REPORTS_DETAILS_FETCH_CANCELED = 'MATCH_REPORTS_DETAILS_FETCH_CANCELED'

export const MATCH_EVENTS_REPORT = 'MATCH_EVENTS_REPORT'
export const MATCH_EVENTS_REPORT_ERROR = 'MATCH_EVENTS_REPORT_ERROR'
export const MATCH_EVENTS_REPORT_FULFILLED = 'MATCH_EVENTS_REPORT_FULFILLED'
export const MATCH_EVENTS_REPORT_CANCELED = 'MATCH_EVENTS_REPORT_CANCELED'

export const MATCH_LOCATIONS_FETCH = 'MATCH_LOCATIONS_FETCH'
export const MATCH_LOCATIONS_FETCH_ERROR = 'MATCH_LOCATIONS_FETCH_ERROR'
export const MATCH_LOCATIONS_FETCH_FULFILLED = 'MATCH_LOCATIONS_FETCH_FULFILLED'
export const MATCH_LOCATIONS_FETCH_CANCELED = 'MATCH_LOCATIONS_FETCH_CANCELED'

export const MATCH_REFEREES_FETCH = 'MATCH_REFEREES_FETCH'
export const MATCH_REFEREES_FETCH_ERROR = 'MATCH_REFEREES_FETCH_ERROR'
export const MATCH_REFEREES_FETCH_FULFILLED = 'MATCH_REFEREES_FETCH_FULFILLED'
export const MATCH_REFEREES_FETCH_CANCELED = 'MATCH_REFEREES_FETCH_CANCELED'

export const MATCH_RATINGS_FETCH = 'MATCH_RATINGS_FETCH'
export const MATCH_RATINGS_FETCH_ERROR = 'MATCH_RATINGS_FETCH_ERROR'
export const MATCH_RATINGS_FETCH_FULFILLED = 'MATCH_RATINGS_FETCH_FULFILLED'
export const MATCH_RATINGS_FETCH_CANCELED = 'MATCH_RATINGS_FETCH_CANCELED'

export const MATCH_RATINGS_ADD = 'MATCH_RATINGS_ADD'
export const MATCH_RATINGS_ADD_ERROR = 'MATCH_RATINGS_ADD_ERROR'
export const MATCH_RATINGS_ADD_FULFILLED = 'MATCH_RATINGS_ADD_FULFILLED'
export const MATCH_RATINGS_ADD_CANCELED = 'MATCH_RATINGS_ADD_CANCELED'

export const MATCH_FAIR_PLAY_SET = 'MATCH_FAIR_PLAY_SET'
export const MATCH_FAIR_PLAY_SET_ERROR = 'MATCH_FAIR_PLAY_SET_ERROR'
export const MATCH_FAIR_PLAY_SET_FULFILLED = 'MATCH_FAIR_PLAY_SET_FULFILLED'
export const MATCH_FAIR_PLAY_SET_CANCELED = 'MATCH_FAIR_PLAY_SET_CANCELED'

export const getInitialState = () =>
  serverResponse({
    audits: null,
    events: serverResponse(),
    like: serverResponse(),
    ratings: serverResponse(),
    reports: serverResponse(),
    reportsDetails: serverResponse(),
  })

export const matchEventsFetch = (matchId) => ({
  payload: {
    matchId,
  },
  type: MATCH_EVENTS_FETCH,
})

export const matchEventsFetchFulfilled = (payload) => ({
  payload,
  type: MATCH_EVENTS_FETCH_FULFILLED,
})

export const matchEventsFetchCanceled = () => ({
  payload: null,
  type: MATCH_EVENTS_FETCH_CANCELED,
})

export const matchEventsFetchError = (payload) => ({
  payload,
  type: MATCH_EVENTS_FETCH_ERROR,
})

export const matchEventsFetchEpic = epicRequest({
  actionType: MATCH_EVENTS_FETCH,
  errorAction: matchEventsFetchError,
  filter: () => !!System.AUTH_HEADERS.Authorization,
  fulfilledAction: matchEventsFetchFulfilled,
  request: (action) => `sports/soccer/match/${action.payload.matchId}/events`,
  untilTypes: MATCH_EVENTS_FETCH_CANCELED,
})

export const matchAuditsFetch = (matchId) => ({
  payload: {
    matchId,
  },
  type: MATCH_AUDITS_FETCH,
})

export const matchAuditsFetchFulfilled = (payload) => ({
  payload,
  type: MATCH_AUDITS_FETCH_FULFILLED,
})

export const matchAuditsFetchCanceled = () => ({
  payload: null,
  type: MATCH_AUDITS_FETCH_CANCELED,
})

export const matchAuditsFetchError = (payload) => ({
  payload,
  type: MATCH_AUDITS_FETCH_ERROR,
})

export const matchAuditsFetchEpic = epicRequest({
  actionType: MATCH_AUDITS_FETCH,
  errorAction: matchAuditsFetchError,
  fulfilledAction: matchAuditsFetchFulfilled,
  request: (action) => `sports/soccer/match/${action.payload.matchId}/audits`,
  untilTypes: MATCH_AUDITS_FETCH_CANCELED,
})

export const matchReportsFetch = (matchId) => ({
  payload: {
    matchId,
  },
  type: MATCH_REPORTS_FETCH,
})

export const matchReportsFetchFulfilled = (payload) => ({
  payload,
  type: MATCH_REPORTS_FETCH_FULFILLED,
})

export const matchReportsFetchCanceled = () => ({
  payload: null,
  type: MATCH_REPORTS_FETCH_CANCELED,
})

export const matchReportsFetchError = (payload) => ({
  payload,
  type: MATCH_REPORTS_FETCH_ERROR,
})

export const matchReportsFetchEpic = epicRequest({
  actionType: MATCH_REPORTS_FETCH,
  errorAction: matchReportsFetchError,
  filter: () => !!System.AUTH_HEADERS.Authorization,
  fulfilledAction: matchReportsFetchFulfilled,
  request: (action) => `sports/soccer/match/${action.payload.matchId}/reports`,
  untilTypes: MATCH_REPORTS_FETCH_CANCELED,
})

export const matchReportsDetailsFetch = (matchId) => ({
  payload: {
    matchId,
  },
  type: MATCH_REPORTS_DETAILS_FETCH,
})

export const matchReportsDetailsFetchFulfilled = (payload) => ({
  payload,
  type: MATCH_REPORTS_DETAILS_FETCH_FULFILLED,
})

export const matchReportsDetailsFetchCanceled = () => ({
  payload: null,
  type: MATCH_REPORTS_DETAILS_FETCH_CANCELED,
})

export const matchReportsDetailsFetchError = (payload) => ({
  payload,
  type: MATCH_REPORTS_DETAILS_FETCH_ERROR,
})

export const matchReportsDetailsFetchEpic = epicRequest({
  actionType: MATCH_REPORTS_DETAILS_FETCH,
  errorAction: matchReportsDetailsFetchError,
  fulfilledAction: matchReportsDetailsFetchFulfilled,
  request: ({ payload }) => `sports/soccer/match/${payload.matchId}/reportsDetails`,
  untilTypes: MATCH_REPORTS_DETAILS_FETCH_CANCELED,
})

export const matchEventsReport = (matchId, reports, lat, lng) => ({
  notification: {
    id: matchId,
    children: 'Reportando cambios...',
  },
  payload: {
    lat,
    lng,
    matchId,
    reports,
  },
  type: MATCH_EVENTS_REPORT,
})

export const matchEventsReportFulfilled = (payload) => ({
  notification: {
    id: payload.originalAction.payload.matchId,
    children: 'En un minuto se verá reflejado',
    title: 'Cambios almacenados',
  },
  payload,
  type: MATCH_EVENTS_REPORT_FULFILLED,
})

export const matchEventsReportCanceled = () => ({
  payload: null,
  type: MATCH_EVENTS_REPORT_CANCELED,
})

export const matchEventsReportError = (payload) => ({
  notification: {
    id: payload.originalAction.payload.matchId,
    title: 'Error al reportar cambios',
  },
  payload,
  type: MATCH_EVENTS_REPORT_ERROR,
})

export const matchEventsReportEpic = epicRequest({
  actionType: MATCH_EVENTS_REPORT,
  errorAction: matchEventsReportError,
  fulfilledAction: matchEventsReportFulfilled,
  maps: [
    (_response, { payload }) => matchEventsFetch(payload.matchId),
    (_response, { payload }) => matchReportsFetch(payload.matchId),
  ],
  request: ({ payload }) => {
    const body = {
      events: payload.reports.map((report) =>
        JSON.stringify({
          confirm: report.confirm,
          player_id: report.player_id,
          report_id: report.report_id,
          second: report.second,
          team_id: report.team_id,
          type: report.type,
        }),
      ),
      lat: payload.lat,
      lng: payload.lng,
    }

    return { body, method: 'post', url: `sports/soccer/match/${payload.matchId}/reports` }
  },
  untilTypes: MATCH_EVENTS_REPORT_CANCELED,
})

export const matchTeamRelationFetch = (teamId) => ({
  payload: {
    teamId,
  },
  type: MATCH_TEAM_RELATION_FETCH,
})

export const matchTeamRelationFetchFulfilled = (payload) => ({
  payload,
  type: MATCH_TEAM_RELATION_FETCH_FULFILLED,
})

export const matchTeamRelationFetchCanceled = () => ({
  payload: null,
  type: MATCH_TEAM_RELATION_FETCH_CANCELED,
})

export const matchTeamRelationFetchError = (payload) => ({
  payload,
  type: MATCH_TEAM_RELATION_FETCH_ERROR,
})

export const matchTeamRelationFetchEpic = epicRequest({
  actionType: MATCH_TEAM_RELATION_FETCH,
  errorAction: matchTeamRelationFetchError,
  filter: () => !!System.AUTH_HEADERS.Authorization,
  fulfilledAction: matchTeamRelationFetchFulfilled,
  overlap: true,
  request: ({ payload }) => `sports/soccer/team/${payload.teamId}/relation`,
  untilTypes: MATCH_TEAM_RELATION_FETCH_CANCELED,
})

export const matchApprove = (matchId, localWalkover, visitorWalkover, bothLose, bothLoseReason) => ({
  payload: {
    bothLose,
    bothLoseReason,
    localWalkover,
    matchId,
    visitorWalkover,
  },
  type: MATCH_APPROVE,
})

export const matchApproveFulfilled = (payload) => ({
  payload,
  type: MATCH_APPROVE_FULFILLED,
})
export const matchApproveError = (payload) => ({
  payload,
  type: MATCH_APPROVE_ERROR,
})

export const matchApproveCanceled = () => ({
  payload: null,
  type: MATCH_APPROVE_CANCELED,
})

export const matchApproveEpic = epicRequest({
  actionType: MATCH_APPROVE,
  errorAction: matchApproveError,
  fulfilledAction: matchApproveFulfilled,
  request: ({ payload }) => ({
    body: {
      bothLose: payload.bothLose ? 1 : 0,
      bothLoseReason: payload.bothLoseReason || '',
      localWalkover: payload.localWalkover ? 1 : 0,
      visitorWalkover: payload.visitorWalkover ? 1 : 0,
    },
    method: 'post',
    url: `sports/soccer/match/${payload.matchId}/approve`,
  }),
  untilTypes: MATCH_APPROVE_CANCELED,
})

export const matchDelete = (matchId) => ({
  payload: {
    matchId,
  },
  type: MATCH_DELETE,
})

export const matchDeleteFulfilled = (payload) => ({
  payload,
  type: MATCH_DELETE_FULFILLED,
})

export const matchDeleteError = (payload) => ({
  payload,
  type: MATCH_DELETE_ERROR,
})

export const matchDeleteCanceled = () => ({
  payload: null,
  type: MATCH_DELETE_CANCELED,
})

export const matchDeleteEpic = epicRequest({
  actionType: MATCH_DELETE,
  errorAction: matchDeleteError,
  fulfilledAction: matchDeleteFulfilled,
  request: ({ payload }) => ({
    method: 'delete',
    url: `sports/soccer/match/${payload.matchId}`,
  }),
  untilTypes: MATCH_DELETE_CANCELED,
})

export const matchDisapprove = (matchId) => ({
  payload: {
    matchId,
  },
  type: MATCH_DISAPPROVE,
})

export const matchDisapproveFulfilled = (payload) => ({
  payload,
  type: MATCH_DISAPPROVE_FULFILLED,
})
export const matchDisapproveError = (payload) => ({
  payload,
  type: MATCH_DISAPPROVE_ERROR,
})

export const matchDisapproveCanceled = () => ({
  payload: null,
  type: MATCH_DISAPPROVE_CANCELED,
})

export const matchDisapproveEpic = epicRequest({
  actionType: MATCH_DISAPPROVE,
  errorAction: matchDisapproveError,
  fulfilledAction: matchDisapproveFulfilled,
  request: ({ payload }) => ({
    method: 'delete',
    url: `sports/soccer/match/${payload.matchId}/disapprove`,
  }),
  untilTypes: MATCH_DISAPPROVE_CANCELED,
})

export const matchSchedule = (matchId, date) => ({
  payload: {
    date,
    matchId,
  },
  type: MATCH_SCHEDULE,
})

export const matchScheduleFulfilled = (payload) => ({
  payload,
  type: MATCH_SCHEDULE_FULFILLED,
})

export const matchScheduleError = (payload) => ({
  payload,
  type: MATCH_SCHEDULE_ERROR,
})

export const matchScheduleCanceled = () => ({
  payload: null,
  type: MATCH_SCHEDULE_CANCELED,
})
export const matchScheduleEpic = epicRequest({
  actionType: MATCH_SCHEDULE,
  errorAction: matchScheduleError,
  fulfilledAction: matchScheduleFulfilled,
  request: ({ payload }) => ({
    method: 'put',
    url: `sports/soccer/match/${payload.matchId}/schedule/${encodeURIComponent(payload.date)}`,
  }),
  untilTypes: MATCH_SCHEDULE_CANCELED,
})

export const matchLocationSet = (matchId, location) => ({
  payload: {
    location,
    matchId,
  },
  type: MATCH_LOCATION_SET,
})

export const matchLocationSetFulfilled = (payload) => ({
  payload,
  type: MATCH_LOCATION_SET_FULFILLED,
})
export const matchLocationSetError = (payload) => ({
  payload,
  type: MATCH_LOCATION_SET_ERROR,
})

export const matchLocationSetCanceled = () => ({
  payload: null,
  type: MATCH_LOCATION_SET_CANCELED,
})
export const matchLocationSetEpic = epicRequest({
  actionType: MATCH_LOCATION_SET,
  errorAction: matchLocationSetError,
  fulfilledAction: matchLocationSetFulfilled,
  request: ({ payload }) => ({
    method: 'put',
    url: `sports/soccer/match/${payload.matchId}/location/${encodeURIComponent(payload.location)}`,
  }),
  untilTypes: MATCH_LOCATION_SET_CANCELED,
})

export const matchRelationFetch = (matchId) => ({
  payload: {
    matchId,
  },
  type: MATCH_RELATION_FETCH,
})

export const matchRelationFetchFulfilled = (payload) => ({
  payload,
  type: MATCH_RELATION_FETCH_FULFILLED,
})

export const matchRelationFetchError = (payload) => ({
  payload,
  type: MATCH_RELATION_FETCH_ERROR,
})

export const matchRelationFetchCanceled = () => ({
  payload: null,
  type: MATCH_RELATION_FETCH_CANCELED,
})

export const matchRelationFetchEpic = epicRequest({
  actionType: MATCH_RELATION_FETCH,
  errorAction: matchRelationFetchError,
  filter: () => !!System.AUTH_HEADERS.Authorization,
  fulfilledAction: matchRelationFetchFulfilled,
  request: ({ payload }) => `sports/soccer/match/${payload.matchId}/relation`,
  untilTypes: MATCH_RELATION_FETCH_CANCELED,
})

export const matchRatingsFetch = (matchId) => ({
  payload: {
    matchId,
  },
  type: MATCH_RATINGS_FETCH,
})

export const matchRatingsFetchFulfilled = (payload) => ({
  payload,
  type: MATCH_RATINGS_FETCH_FULFILLED,
})
export const matchRatingsFetchError = (payload) => ({
  payload,
  type: MATCH_RATINGS_FETCH_ERROR,
})

export const matchRatingsFetchCanceled = () => ({
  payload: null,
  type: MATCH_RATINGS_FETCH_CANCELED,
})

export const matchRatingsFetchEpic = epicRequest({
  actionType: MATCH_RATINGS_FETCH,
  errorAction: matchRatingsFetchError,
  filter: !!System.AUTH_HEADERS.Authorization,
  fulfilledAction: matchRatingsFetchFulfilled,
  request: ({ payload }) => `sports/soccer/match/${payload.matchId}/ratings`,
  untilTypes: MATCH_RATINGS_FETCH_CANCELED,
})

export const matchRatingsAdd = (matchId, component, rate) => ({
  payload: {
    component,
    matchId,
    rate,
  },
  type: MATCH_RATINGS_ADD,
})

export const matchRatingsAddFulfilled = (payload) => ({
  payload,
  type: MATCH_RATINGS_ADD_FULFILLED,
})
export const matchRatingsAddError = (payload) => ({
  payload,
  type: MATCH_RATINGS_ADD_ERROR,
})

export const matchRatingsAddCanceled = () => ({
  payload: null,
  type: MATCH_RATINGS_ADD_CANCELED,
})

export const matchRatingsAddEpic = epicRequest({
  actionType: MATCH_RATINGS_ADD,
  debounce: 1000,
  errorAction: matchRatingsAddError,
  filter: !!System.AUTH_HEADERS.Authorization,
  fulfilledAction: matchRatingsAddFulfilled,
  request: ({ payload }) => ({
    body: {
      component: payload.component,
      rate: payload.rate,
    },
    method: 'post',
    url: `sports/soccer/match/${payload.matchId}/ratings`,
  }),
  untilTypes: MATCH_RATINGS_ADD_CANCELED,
})

export const matchFairPlaySet = (matchId, local, visitor) => ({
  payload: {
    local,
    matchId,
    visitor,
  },
  type: MATCH_FAIR_PLAY_SET,
})

export const matchFairPlaySetFulfilled = (payload) => ({
  payload,
  type: MATCH_FAIR_PLAY_SET_FULFILLED,
})
export const matchFairPlaySetError = (payload) => ({
  payload,
  type: MATCH_FAIR_PLAY_SET_ERROR,
})

export const matchFairPlaySetCanceled = () => ({
  payload: null,
  type: MATCH_FAIR_PLAY_SET_CANCELED,
})

export const matchFairPlaySetEpic = epicRequest({
  actionType: MATCH_FAIR_PLAY_SET,
  errorAction: matchFairPlaySetError,
  filter: !!System.AUTH_HEADERS.Authorization,
  fulfilledAction: matchFairPlaySetFulfilled,
  request: ({ payload }) => ({
    method: 'put',
    url: `sports/soccer/match/${payload.matchId}/fair_play/${payload.local}/${payload.visitor}`,
  }),
  untilTypes: MATCH_FAIR_PLAY_SET_CANCELED,
})

export const matchFetch = (matchId) => ({
  payload: {
    matchId,
  },
  type: MATCH_FETCH,
})

export const matchFetchFulfilled = (payload) => ({
  payload,
  type: MATCH_FETCH_FULFILLED,
})
export const matchFetchError = (payload) => ({
  payload,
  type: MATCH_FETCH_ERROR,
})

export const matchFetchCanceled = () => ({
  payload: null,
  type: MATCH_FETCH_CANCELED,
})

export const matchFetchEpic = epicRequest({
  actionType: MATCH_FETCH,
  errorAction: matchFetchError,
  fulfilledAction: matchFetchFulfilled,
  maps: [
    ({ response }) => tournamentLastViewed(response?.data?.[0]?.stage?.tournament?.tournament?.id),
    ({ response }) => matchEventsFetch(response?.data?.[0]?.id),
    ({ response }) => matchReportsFetch(response?.data?.[0]?.id),
    ({ response }) => matchRatingsFetch(response?.data?.[0]?.id),
    ({ response }) => matchTeamRelationFetch(response?.data?.[0]?.local?.id),
    ({ response }) => matchTeamRelationFetch(response?.data?.[0]?.visitor?.id),
    ({ response }) => matchRelationFetch(response?.data?.[0]?.id),
  ],
  request: ({ payload }) => `sports/soccer/match/${payload.matchId}`,
  untilTypes: MATCH_FETCH_CANCELED,
})

export const matchTeamLike = (teamId, like) => ({
  payload: {
    like,
    teamId,
  },
  type: MATCH_TEAM_LIKE,
})

export const matchTeamLikeFulfilled = (payload) => ({
  payload,
  type: MATCH_TEAM_LIKE_FULFILLED,
})

export const matchTeamLikeCanceled = () => ({
  payload: null,
  type: MATCH_TEAM_LIKE_CANCELED,
})

export const matchTeamLikeError = (payload) => ({
  payload,
  type: MATCH_TEAM_LIKE_ERROR,
})

export const matchTeamLikeEpic = epicRequest({
  actionType: MATCH_TEAM_LIKE,
  debounce: 700,
  errorAction: matchTeamLikeError,
  fulfilledAction: matchTeamLikeFulfilled,
  request: ({ payload }) => ({
    method: payload.like ? 'post' : 'delete',
    url: payload.like ? `sports/soccer/team/${payload.teamId}/like` : `sports/soccer/team/${payload.teamId}/unfollow`,
  }),
  untilTypes: MATCH_TEAM_LIKE_CANCELED,
})

export const matchLocationsFetch = (matchId) => ({
  payload: {
    matchId,
  },
  type: MATCH_LOCATIONS_FETCH,
})

export const matchLocationsFetchFulfilled = (payload) => ({
  payload,
  type: MATCH_LOCATIONS_FETCH_FULFILLED,
})
export const matchLocationsFetchError = (payload) => ({
  payload,
  type: MATCH_LOCATIONS_FETCH_ERROR,
})

export const matchLocationsFetchCanceled = () => ({
  payload: null,
  type: MATCH_LOCATIONS_FETCH_CANCELED,
})

export const matchLocationsFetchEpic = epicRequest({
  actionType: MATCH_LOCATIONS_FETCH,
  errorAction: matchLocationsFetchError,
  fulfilledAction: matchLocationsFetchFulfilled,
  request: ({ payload }) => `sports/soccer/match/${payload.matchId}/locations`,
  untilTypes: MATCH_LOCATIONS_FETCH_CANCELED,
})

export const matchRefereeSet = (matchId, referee) => ({
  payload: {
    matchId,
    referee,
  },
  type: MATCH_REFEREE_SET,
})

export const matchRefereeSetFulfilled = (payload) => ({
  payload,
  type: MATCH_REFEREE_SET_FULFILLED,
})
export const matchRefereeSetError = (payload) => ({
  payload,
  type: MATCH_REFEREE_SET_ERROR,
})

export const matchRefereeSetCanceled = () => ({
  payload: null,
  type: MATCH_REFEREE_SET_CANCELED,
})

export const matchRefereeSetEpic = epicRequest({
  actionType: MATCH_REFEREE_SET,
  errorAction: matchRefereeSetError,
  fulfilledAction: matchRefereeSetFulfilled,
  request: ({ payload }) => ({
    method: 'put',
    url: `sports/soccer/match/${payload.matchId}/referee/${encodeURIComponent(payload.referee)}`,
  }),
  untilTypes: MATCH_REFEREE_SET_CANCELED,
})

export const matchRefereesFetch = (matchId) => ({
  payload: {
    matchId,
  },
  type: MATCH_REFEREES_FETCH,
})

export const matchRefereesFetchFulfilled = (payload) => ({
  payload,
  type: MATCH_REFEREES_FETCH_FULFILLED,
})
export const matchRefereesFetchError = (payload) => ({
  payload,
  type: MATCH_REFEREES_FETCH_ERROR,
})

export const matchRefereesFetchCanceled = () => ({
  payload: null,
  type: MATCH_REFEREES_FETCH_CANCELED,
})

export const matchRefereesFetchEpic = epicRequest({
  actionType: MATCH_REFEREES_FETCH,
  errorAction: matchRefereesFetchError,
  fulfilledAction: matchRefereesFetchFulfilled,
  request: ({ payload }) => `sports/soccer/match/${payload.matchId}/referees`,
  untilTypes: MATCH_REFEREES_FETCH_CANCELED,
})
